// ----------------------------------------------------------------------

export const mockImgCover = (index) => `${process.env.PUBLIC_URL}/static/mock-images/covers/cover_${index}.jpg`;
export const mockImgProduct = (index) => `${process.env.PUBLIC_URL}/static/mock-images/products/product_${index}.jpg`;
export const mockImgAvatar = (index) => `${process.env.PUBLIC_URL}/static/mock-images/avatars/avatar_${index}.jpg`;
